import React,{useContext} from "react"
import Header from '../../organism/header';
import Footer from '../../organism/footer';
import Close from '../../content/close';

import HtmlOverlay from "../../content/htmlOverlay"

import { AppContext } from '../../../context'

import TableOfContentsPage from "../contents"
import LangSelectionPage from "../lang";
import styled from "@emotion/styled";

import PropTypes from 'prop-types';

const HudContainer = styled.div`
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    postion: absolute;
    
    &::after {
      content: '';
      display: block;
      position: absolute;
      box-sizing: border-box;
      left: 4px;
      right: 4px;
      top: 4px;
      bottom: 4px;

      border: 1px solid rgba(255, 255, 255, 0.15);
      flex: none;
      order: 1;
      flex-grow: 0;
      z-index: 1;
      pointer-events: none;
  }
`

export const Hud = ({hide}) => {
  return hide ? null : (
    <HudContainer>
      <Header />
      <Footer />
      <HtmlOverlay />
      <TableOfContentsPage/>  
      <LangSelectionPage />     
      <Close />
    </HudContainer>
  )
}

Hud.propTypes = {
  hide: PropTypes.bool,
}

export default () => {
  const {ready} = useContext(AppContext)
  return (
      <Hud hide={!ready} />
  )
};
